<div class="qu-container">

  <!-- ═══════════════════════════════════════════════════════════════════════
       ALL LOGS VIEW
  ════════════════════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="viewMode === 'all'">

    <!-- ─── Stats Row ─── -->
    <div class="cl-stats-row" *ngIf="!loading">
      <div class="cl-stat-card">
        <span class="cl-stat-value">{{ allLogs.length }}</span>
        <span class="cl-stat-label">Total Queries</span>
      </div>
      <div class="cl-stat-card cl-stat-found">
        <span class="cl-stat-value">{{ answeredCount }}</span>
        <span class="cl-stat-label">Answered</span>
      </div>
      <div class="cl-stat-card cl-stat-missed">
        <span class="cl-stat-value">{{ unansweredCount }}</span>
        <span class="cl-stat-label">Not Found</span>
      </div>
      <div class="cl-stat-card cl-stat-sessions">
        <span class="cl-stat-value">{{ uniqueSessionCount }}</span>
        <span class="cl-stat-label">Sessions</span>
      </div>
    </div>

    <!-- ─── Action Bar ─── -->
    <div class="qu-action-bar">
      <div class="qu-search-wrap">
        <input
          type="text"
          [(ngModel)]="search"
          (ngModelChange)="onSearchChange()"
          placeholder="Search by question, session, user, document..."
          class="qu-input qu-input-search"
        />
        <button *ngIf="search" (click)="search = ''; onSearchChange()" class="qu-clear-btn">&#x2715;</button>
      </div>

      <div class="cl-filter-group">
        <button
          class="cl-filter-btn"
          [class.active]="filterAnswered === 'all'"
          (click)="filterAnswered = 'all'; onFilterChange()">All</button>
        <button
          class="cl-filter-btn cl-filter-found"
          [class.active]="filterAnswered === 'found'"
          (click)="filterAnswered = 'found'; onFilterChange()">Answered</button>
        <button
          class="cl-filter-btn cl-filter-missed"
          [class.active]="filterAnswered === 'not_found'"
          (click)="filterAnswered = 'not_found'; onFilterChange()">Not Found</button>
      </div>

      <button class="qu-btn qu-btn-success" (click)="loadAllLogs()">Refresh</button>
    </div>

    <!-- ─── Table ─── -->
    <div class="qu-table-wrap">

      <!-- Skeleton -->
      <table *ngIf="loading" class="qu-table">
        <thead>
          <tr>
            <th class="qu-th qu-th-num">#</th>
            <th class="qu-th">Question</th>
            <th class="qu-th">Session</th>
            <th class="qu-th">User</th>
            <th class="qu-th">Answer</th>
            <th class="qu-th">Document</th>
            <th class="qu-th">Time</th>
            <th class="qu-th">Asked At</th>
            <th class="qu-th qu-th-action">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sk of skeletonRows" class="qu-skeleton-row">
            <td class="qu-td"><div class="qu-sk qu-sk-xs"></div></td>
            <td class="qu-td"><div class="qu-sk"></div></td>
            <td class="qu-td"><div class="qu-sk qu-sk-sm"></div></td>
            <td class="qu-td"><div class="qu-sk qu-sk-sm"></div></td>
            <td class="qu-td"><div class="qu-sk qu-sk-xs"></div></td>
            <td class="qu-td"><div class="qu-sk qu-sk-sm"></div></td>
            <td class="qu-td"><div class="qu-sk qu-sk-xs"></div></td>
            <td class="qu-td"><div class="qu-sk qu-sk-sm"></div></td>
            <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
          </tr>
        </tbody>
      </table>

      <!-- Data Table -->
      <table *ngIf="!loading" class="qu-table">
        <thead>
          <tr>
            <th class="qu-th qu-th-num">#</th>
            <th class="qu-th">Question</th>
            <th class="qu-th">Session</th>
            <th class="qu-th">User</th>
            <th class="qu-th">Answer</th>
            <th class="qu-th">Document</th>
            <th class="qu-th">Response Time</th>
            <th class="qu-th">Asked At</th>
            <th class="qu-th qu-th-action">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let log of pageData; let idx = index"
            class="qu-tr"
            [ngClass]="getRowClass(idx)">

            <td class="qu-td qu-td-num">{{ getRowIndex(idx) }}</td>

            <td class="qu-td cl-td-question" [title]="log.userQuestion">
              {{ truncate(log.userQuestion) }}
            </td>

            <td class="qu-td cl-td-session" [title]="log.sessionId">
              <span class="cl-session-tag">{{ shortSession(log.sessionId) }}</span>
            </td>

            <td class="qu-td">{{ log.userId || '—' }}</td>

            <td class="qu-td">
              <span class="cl-badge" [ngClass]="log.answerFound ? 'cl-badge-found' : 'cl-badge-missed'">
                {{ log.answerFound ? 'Found' : 'Not Found' }}
              </span>
            </td>

            <td class="qu-td cl-td-doc" [title]="log.topDocumentName || ''">
              {{ log.topDocumentName ? truncate(log.topDocumentName, 30) : '—' }}
            </td>

            <td class="qu-td cl-td-time">{{ formatResponseTime(log.responseTimeMs) }}</td>

            <td class="qu-td cl-td-date">{{ formatDate(log.createdAt) }}</td>

            <td class="qu-td qu-td-action">
              <button class="cl-session-btn" (click)="viewSession(log.sessionId)" title="View session thread">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
                Session
              </button>
            </td>
          </tr>

          <tr *ngIf="pageData.length === 0">
            <td colspan="9" class="qu-td qu-td-empty">No logs found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ─── Pagination ─── -->
    <div class="qu-pagination">
      <div class="qu-page-nav">
        <button class="qu-btn qu-btn-page" [disabled]="page === 1" (click)="page = page - 1; onPageChange()">Prev</button>
        <button class="qu-btn qu-btn-page" [disabled]="page === totalPages" (click)="page = page + 1; onPageChange()">Next</button>
        <span class="qu-page-info">Page {{ page }} of {{ totalPages }}</span>
      </div>
      <span class="qu-count">{{ filteredLogs.length }} of {{ allLogs.length }} entries</span>
      <div class="qu-rows-wrap">
        <span class="qu-label">Rows per page</span>
        <select [(ngModel)]="rowsPerPage" (ngModelChange)="page = 1; onPageChange()" class="qu-select">
          <option [value]="10">10</option>
          <option [value]="25">25</option>
          <option [value]="50">50</option>
        </select>
      </div>
    </div>

  </ng-container>

  <!-- ═══════════════════════════════════════════════════════════════════════
       SESSION THREAD VIEW
  ════════════════════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="viewMode === 'session'">

    <!-- ─── Session Header ─── -->
    <div class="cl-session-header">
      <button class="cl-back-btn" (click)="backToAll()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Back to All Logs
      </button>
      <div class="cl-session-info">
        <span class="cl-session-label">Session</span>
        <span class="cl-session-id">{{ selectedSessionId }}</span>
      </div>
      <span class="cl-session-count" *ngIf="!sessionLoading">{{ sessionLogs.length }} message{{ sessionLogs.length !== 1 ? 's' : '' }}</span>
    </div>

    <!-- ─── Loading ─── -->
    <div *ngIf="sessionLoading" class="cl-session-loading">
      <div class="cl-spinner"></div>
      <p>Loading session...</p>
    </div>

    <!-- ─── Thread ─── -->
    <div class="cl-thread" *ngIf="!sessionLoading">

      <div *ngIf="sessionLogs.length === 0" class="qu-td qu-td-empty" style="text-align:center; padding:40px">
        No messages found for this session.
      </div>

      <div *ngFor="let log of sessionLogs; let i = index" class="cl-message-card">

        <!-- Question -->
        <div class="cl-q-row">
          <div class="cl-avatar cl-avatar-user">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <div class="cl-bubble cl-bubble-user">
            <span class="cl-meta">{{ log.userId || 'Staff' }} &middot; {{ formatDate(log.createdAt) }}</span>
            <p class="cl-text">{{ log.userQuestion }}</p>
          </div>
        </div>

        <!-- Answer -->
        <div class="cl-a-row">
          <div class="cl-avatar cl-avatar-bot">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              <circle cx="12" cy="16" r="1" fill="currentColor"/>
            </svg>
          </div>
          <div class="cl-bubble cl-bubble-bot" [ngClass]="!log.answerFound ? 'cl-bubble-missed' : ''">
            <div class="cl-answer-meta">
              <span class="cl-badge" [ngClass]="log.answerFound ? 'cl-badge-found' : 'cl-badge-missed'">
                {{ log.answerFound ? 'Answer Found' : 'Not in Documents' }}
              </span>
              <span class="cl-sim-score" *ngIf="log.answerFound">
                {{ (log.topSimilarityScore * 100).toFixed(0) }}% match
              </span>
              <span class="cl-resp-time">{{ formatResponseTime(log.responseTimeMs) }}</span>
            </div>
            <p class="cl-text">{{ log.generatedAnswer }}</p>

            <!-- Source info -->
            <div class="cl-source-info" *ngIf="log.answerFound && log.topDocumentName">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
              </svg>
              <span class="cl-source-doc">{{ log.topDocumentName }}</span>
              <span *ngIf="log.pagesReferenced" class="cl-source-pages">pp. {{ log.pagesReferenced }}</span>
              <span *ngIf="log.sectionsReferenced" class="cl-source-sections">| {{ log.sectionsReferenced }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

  </ng-container>

</div>
